import styled from '@emotion/styled';

export const Screen = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
